import React from 'react';
import { Alert } from 'antd';
import { InfoIcon } from 'components/Shared/Icons';
import useTranslation from 'utils/hooks/useTranslation';
import { formatMinorUnits } from 'pages/Wallet/helper';

import styles from './style.module.scss';

const KEY_PREFIX = 'corporateAccounts.wallet.dashboard.bankTransferSubmitted';

// Replaces the reminder once the transfer has been confirmed.
const BankTransferSubmitted = ({ amountMinor, currency, onClose }) => {
  const { translateText } = useTranslation();

  return (
    <Alert
      type="info"
      closable
      onClose={onClose}
      className={styles.bankTransferReminder}
      icon={<InfoIcon />}
      showIcon
      data-testid="walletBankTransferSubmitted"
      message={
        <span className={styles.bankTransferReminderTitle}>
          {translateText(`${KEY_PREFIX}.title`)}
        </span>
      }
      description={translateText(`${KEY_PREFIX}.description`, {
        amount: formatMinorUnits(amountMinor, currency),
      })}
    />
  );
};

export default BankTransferSubmitted;
